var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 53,
    viewBox: "0 0 103 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 53C0 53 14.8197 27.1531 32.0444 23.6687C43.4889 19.0876 103 31.3037 103 0C103 0 95.3704 11.4526 43.4889 11.4526C22.6914 11.4526 16.7424 22.0381 12.8528 26.9244C1.18394 41.5601 0 53 0 53Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.836 26.8777C46.857 26.8777 74.7692 26.709 82.9472 26.8777C78.9297 36.8422 57.1509 36.0977 45.8347 35.9406C23.2023 35.6265 18.4336 38.1743 18.4336 38.1743C18.4336 38.1743 24.8533 26.8777 40.836 26.8777Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2501 39.6697C36.2711 39.6697 46.4526 39.501 54.6254 39.6697C50.6131 49.6343 39.67 48.7327 28.3538 48.7327C12.7238 48.7327 7.84766 50.9664 7.84766 50.9664C7.84766 50.9664 14.2673 39.6697 30.2501 39.6697Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.31196cc54af00403efc274a6869b3d45.svg";
export { ForwardRef as ReactComponent };